<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.medicalFiles', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">

                    <b-form-group
                            id="patient-group"
                            :label="$tc('message.patients', 1)"
                            label-for="patient">
                        <b-form-select
                                id="patient"
                                v-model="$v.form.patient_id.$model"
                                :state="$v.form.patient_id.$dirty ? !(errorshasField('patient_id') || $v.form.patient_id.$error) : null"
                                :options="mPatients"
                                required
                                @focus="clearErrorField('patient_id')"
                        ></b-form-select>

                        <b-form-invalid-feedback v-if="!$v.form.patient_id.required">
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>

                        <b-form-invalid-feedback v-else-if="errorshasField('patient_id')">
                            {{ getErrorsField('patient_id') }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button type="submit" variant="primary" disabled>
                                {{ $t('message.edit') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>

                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';

    export default {
        name: "EditMedicalFile",

        computed: {
            ...mapGetters(["file", "patients", "errors",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },
            form: function() {
                return this.file;
            },

            mPatients: function() {
                let sArray = [];

                _.forOwn(this.patients, function(value, key) {
                    sArray.push({ text: value.user.nom, value: value.user.id });
                });

                return sArray;
            }
        },

        data() {
            return {
                file_id: this.$route.params.file,
                show: true
            }
        },

        methods: {
            getMedicalFile: function() {
                let args = {
                    file: this.file_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getMedicalFile', { args, errorMessages });
            },

            getPatients: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getPatients', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        file: this.file_id,
                        patient_id: this.form.patient_id
                    };

                    let successMessage = this.$i18n.t('message.medicalFileUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateMedicalFile', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.patient_id = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                patient_id: {
                    required
                }
            }
        },

        mounted() {
            // Retrieve medical file
            this.getMedicalFile();

            // Retrieve list of patients
            this.getPatients();
        }
    }
</script>

<style scoped>

</style>